import * as _ from 'lodash';
import { Pipe, PipeTransform } from '@angular/core';
import { StudentQuery } from './student.query';

@Pipe({
    name: 'dataFilterStudents'
})
export class StudentFilterPipe implements PipeTransform {
    transform(array: any[], query: StudentQuery): any {
        return _.filter(array, (row) => {
            if (query.staleOnly && query.freshCutoff &&
                row.dataConfirmedAt && row.dataConfirmedAt >= query.freshCutoff) {
                return false;
            }
            if (query.text) {
                for (const child of row.children) {
                    if ((child.firstname && _.toLower(child.firstname).indexOf(_.toLower(query.text)) > -1) ||
                        (child.lastname && _.toLower(child.lastname).indexOf(_.toLower(query.text)) > -1)) {
                            return true;
                        }
                }

                return (row.firstname && _.toLower(row.firstname).indexOf(_.toLower(query.text)) > -1) ||
                    (row.lastname && _.toLower(row.lastname).indexOf(_.toLower(query.text)) > -1) ||
                    (row.secret && _.toLower(row.secret).indexOf(_.toLower(query.text)) > -1) ||
                    (row.description && _.toLower(row.description).indexOf(_.toLower(query.text)) > -1) ||
                    (row.address && _.toLower(row.address).indexOf(_.toLower(query.text)) > -1) ||
                    (row.city && _.toLower(row.city).indexOf(_.toLower(query.text)) > -1) ||
                    (row.zipCode && _.toLower(row.zipCode).indexOf(_.toLower(query.text)) > -1) ||
                    (row.email && _.toLower(row.email).indexOf(_.toLower(query.text)) > -1) ||
                    (row.tokens && row.tokens.includes && row.tokens.includes(query.text));
            } else {
                return true;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/students/shared/student.pipe.ts